// TanStack Query cache keys for admin/refunds.
import type { ListRefundsParams } from "./api";

export const adminRefundKeys = {
  all: ["admin", "refunds"] as const,
  list: (filters: ListRefundsParams) =>
    ["admin", "refunds", "list", filters] as const,
  detail: (requestId: string) =>
    ["admin", "refunds", "detail", requestId] as const,
};
